const MuiChip = ({ _palette }) => ({
  styleOverrides: {
    root: {
      padding: '4px 8px',
      gap: '4px',
      height: 'unset',
      fontWeight: ' 500 !important',
      textTransform: 'capitalize',
      '&.MuiChip-filledDefault': {
        backgroundColor: '#F1F1F1',
        '& .MuiChip-label': {
          color: '#57555C',
        },
      },
      '& .MuiSvgIcon-root': {
        fontSize: '12px',
        fontWeight: 500,
        lineHeight: '18px',
        margin: '0',
      },
      '&.MuiChip-outlinedError': {
        backgroundColor: '#FBEEED',
        color: '#B32318',
        borderColor: '#FBEEED',
      },
      '& .MuiChip-label': {
        fontSize: '12px',
        fontWeight: '500 !important',
        lineHeight: '18px',
        padding: '0px',
        margin: '0',
      },
      '&.MuiChip-colorSuccess': {
        background: '#EFF8EF',
        color: '#2E964B',
      },
      '&.MuiChip-colorWarning': {
        background: '#FEF0C7',
        color: '#F4780B',
      },
      '&.MuiChip-colorError': {
        backgroundColor: '#FBEEED',
        color: '#B32318',
      },
      '&.MuiChip-colorPrimary': {
        backgroundColor: '#E5F6FF',
        color: '#146DFF',
      },
      '&.MuiChip-filledError': {
        backgroundColor: '#FBEEED',
        color: '#B32318',
      },
      '&.MuiChip-colorInfo': {
        backgroundColor: '#F5F5F6',
        color: '#5B5B5F',
      },
      '& .MuiChip-icon': { marginRight: '0', marginLeft: '0' },
    },
  },
});

export default MuiChip;
